import { FeaturedIcon, slugify } from '@prishapolicy/shared/ui';
import { ReactNode } from 'react';
import InformationFillIcon from 'remixicon-react/InformationFillIcon';
export const Callout = (props: { title: string; titleAs?: `h${2 | 3 | 4 | 5 | 6}`; body: ReactNode }) => {
  const TitleRenderer = props.titleAs || 'h3';
  return (
    <div className={`relative flex`} id={slugify(props.title)}>
      <div className="bg-primary w-8 rounded-l-lg"></div>
      <div className="absolute left-2.5 top-6">
        <FeaturedIcon size="xl" icon={InformationFillIcon} />
      </div>
      <div className="not-prose border-primary flex-1 rounded-r-lg border-2 py-8 pl-10 pr-6">
        <TitleRenderer className="text-title-6 font-bold">{props.title}</TitleRenderer>
        <div className="mt-3">{props.body}</div>
      </div>
    </div>
  );
};
